<script setup lang="ts">
/**
 * The command body of an office ribbon, under `NxOfficeRibbon`'s tab strip:
 * the active tab's `NxRibbonGroup`s side by side at the ribbon's fixed height.
 * It never grows with its content; when the groups are wider than the window
 * it scrolls sideways with a thin scrollbar. Its height follows the ribbon
 * (`density`, the shared document workspace).
 *
 * Menus and popovers opened from its commands must live in the top layer
 * (`NxContextMenu`, `NxPopover`, the ribbon menu buttons) — the scrolling body
 * clips everything else.
 */
import '../office-ribbon.css';
</script>

<template>
  <div class="nx-ribbon-body"><slot /></div>
</template>
